import { TTranslationFunction } from '@/types'

import { TVideo } from '../../contentFormSections/VideoForm/VideoFormModel'

export const videoDemoContent = (t: TTranslationFunction) => {
	return {
		headline: t('generator__videos_screen__headline_fallback'),
		description: t('generator__videos_screen__description_fallback'),
		buttons: [
			{
				title: t('auth__login__cta_forgot_action'),
				url: 'www.google.com',
			},
		],
		videos: [
			{
				video: {
					name: t('generator__videos_screen__demo_firstvideo_name'),
					originalName: t('generator__videos_screen__demo_firstvideo_name'),
					description: t(
						'generator__videos_screen__demo_firstvideo_description',
					),
					source: {
						demo: '/web-app/qr-preview-demos/videos/image-1.webp',
						url: '',
					},
				},
			} as TVideo,
			{
				video: {
					name: t('generator__videos_screen__demo_secondvideo_name'),
					originalName: t('generator__videos_screen__demo_secondvideo_name'),
					description: t(
						'generator__videos_screen__demo_secondvideo_description',
					),
					source: {
						demo: '/web-app/qr-preview-demos/videos/image-2.webp',
						url: '',
					},
				},
			} as TVideo,
		],
	}
}
